export const h = {
	quantity: "en stock",
	brand: "marca",
	sku: "SKU",
	model: "modelo",
	addCart: "agregar al carrito",
	buyNow: "Comprar ahora",
	productDetail: "Detalles de producto",
	attribute: "Attribute",
	quantityExits: "En stock",
	quantityNone: "Agotado",

	// 账单页面
	email: "Correo electrónico",
	errorEmail: "Por favor, introduce un correo válido",
	contact: 'Contacto',
	sippingAddress: 'Dirección de envío',
	name: "Nombre",
	nameError: "Por favor, introduce tu nombre",
	address1: "Dirección 1",
	address1Error: "Por favor, introduce la dirección 1",
	address2: "Dirección 2",
	emailCode: "Código postal",
	phone: "Número de teléfono",
	city: "Ciudad",
	cityError: "Por favor, introduce la ciudad",
	country: "País",
	countryError: "Por favor, introduce el país",
	province: "Provincia",
	provinceError: "Por favor, introduce la provincia",
	payWay: "Método de pago",
	sendWay: "Método de envío",
	loginText: "Iniciar sesión / Registrarse",
	cartNum: "Total del carrito",
	orderRemarks: "Notas del pedido",
	discountCode: "Introduce el código de descuento",
	apply: "Aplicar",
	submitOrder: "Enviar pedido",


	classify: "Categoría",
	price: "Precio",
	allNum: "Total",
	defaultTit: "Predeterminado",
	salesLowToHigh: "Ventas (Bajo - Alto)",
	salesHighToLow: "Ventas (Alto - Bajo)",
	nameAtoZ: "Nombre (A - Z)",
	nameZtoA: "Nombre (Z - A)",
	priceLowtoHeight: "Precio (Bajo - Alto)",
	priceHeighttoLow: "Precio (Alto - Bajo)",
	selectClassfiy: "Seleccionar categoría",
	goodCart: "Carrito",
	checkout: "Pagar",
	pay: "Pago",
	goods: "Producto",
	num: "Cantidad",
	total: "Subtotal",
	action: "Acción",
	del: "Eliminar",
	priceTotal: "Total",
	all: "Todos",
	selectd: "Seleccionado",
	goCheckout: "Ir a pagar",
	linkGoods: "Productos relacionados",
	noData: "No hay datos disponibles",
	myOrder: "Mis pedidos",
	changeUserInfo: "Modificar información personal",
	changePassword: "Cambiar contraseña",
	myAddress: "Mis direcciones",
	myWishlist: "Mi lista de deseos",
	myRmas: "Mis postventas",
	userCommission: "Comisión de miembro",
	commissionUsers: "Relaciones de miembros",
	loginOut: "Cerrar sesión",
	orderId: "Número de pedido",

	lookDetail: "Ver detalles",
	saleService: "Solicitar servicio postventa",
	confirmReceivedGoods: "Confirmar recepción",
	goPay: "Ir a pagar",
	cancelOrder: "Cancelar pedido",

	orderDetail: "Detalles del pedido",
	created_at: "Fecha de creación",
	status_format: "Estado del pedido",
	total_format: "Importe del pedido",
	payment_method_name: "Método de pago",
	shipping_method_name: "Método de envío",

	addressInfo: "Información de dirección",
	name: "Nombre",
	address: "Dirección",
	payGoods: "Productos pedidos",

	sendCompany: "Empresa de mensajería",
	sendNum: "Número de seguimiento",
	updateTime: "Fecha de actualización",
	memo: "Notas",
	payOrderAddress: "Dirección de facturación",
	allOrder: "Todos los pedidos",
	waitPay: "Pendiente de pago",
	waitSend: "Pendiente de envío",
	waitReceiving: "Pendiente de recepción",
	completed: "Completado",
	confirm: "Confirmar",
	tips: "Aviso",
	cancel: "Cancelar",
	changeHeadImg: "Cambiar avatar",
	uploadTit: "Subir imagen JPEG o PNG. Tamaño recomendado: 300 x 300.",
	imgSizeTips: "¡El tamaño de la imagen no puede exceder 2 MB!",
	imgTypeTips: "¡Solo se permiten formatos JPG/PNG!",
	serviceType: "Tipo de servicio",
	returnNum: "Cantidad de devolución/cambio",
	isOpend: "¿Está abierto el embalaje?",
	returnReason: "Motivo de devolución/cambio",
	yes: "Sí",
	no: "No",
	returnGoods: "Devolución",
	exchange: "Cambio",
	repair: "Reparación",
	reissue: "Reenvío",
	refund: "Solo reembolso",
	returnNumError: "Por favor ingrese la cantidad de devolución/cambio",

	oldPassword: "Contraseña antigua",
	newPassword: "Nueva contraseña",
	confirmNewPassword: "Confirmar nueva contraseña",

	wishlist: "Eliminar de lista de deseos",
	look: "Ver",
	opendPkg: "Embalaje abierto",
	img: "Imagen",
	afterSales: "Detalles postventa",

	balance: "Saldo disponible",
	waitAmount: "Importe pendiente",
	withdrawaled: "Retirado",
	withdrawal: "Retirar",
	allCommission: "Comisión total",
	startTime: "Hora de inicio",
	endTime: "Hora de finalización",
	search: "Buscar",

	rebateLevel: "Nivel de rebaja",
	CommissionRate: "Tasa de comisión",
	commission: "Comisión",
	settlementStatus: "Estado de liquidación",
	time: "Tiempo",
	WithdrawalAmount: "Importe de retiro",
	peleaseSelect: "Por favor seleccione",
	withdrawalUser: "Cuenta de retiro",
	peleaseIpt: "Por favor ingrese",
	submitSuccess: "Enviado con éxito",
	shareLink: "Compartir enlace",
	superior: "Mi superior directo",
	wu: "Ninguno",
	subordinate: "Mis subordinados",
	addTime: "Fecha de ingreso",
	userAccount: "Cuenta",
	recommendationCode: "Código de recomendación",
	copySuccess: "Copiado con éxito",
	subPay: "Enviar pago",
	iptCardholder_Name: "Por favor ingrese el nombre del titular",

	copy: "copia",

	"home": "Inicio",
	"categoriesPage": "Categorías",
	"brandsPage": "Marcas",
	"brandsPageList": "Productos de marca",
	"productsPage": "Productos",
	"wishlistPage": "Mi lista de deseos",
	"accountPage": "Mis pedidos",
	"cartsPage": "Carrito",
	"checkoutPage": "Pagar",
	"passwordPage": "Cambiar contraseña",
	"editPage": "Editar información",
	"addressesPage": "Editar dirección",
	"rmasPage": "Relaciones de membresía",
	"commissionPage": "Comisión de miembro",
	"success_order_checkoutPage": "Pago de pedido",
	"page_categoriesPage": "Categorías de artículos",
	"userloginPage": "Iniciar sesión",
	"pagesPage": "Artículos",

	hotGoods: "Productos populares",
	newGoods: "Productos nuevos",
	visitGoods: "Más visitados",
	allGoods: "Todos los productos",
	evaluation: "Evaluaciones",

	"first_name": "Apellido",
	"first_nameError": "Por favor, ingrese su apellido",
	"last_name": "Nombre",
	"last_nameError": "Por favor, ingrese su nombre",

	"comment": "Contenido",
	"noContent": "Aún no hay comentarios",
	"author": "Autor",
	"scoreNum": "Puntuación",
	"commentTit": "Comentarios",

	send: "Enviar",
	noPayWay: "No hay métodos de pago disponibles",
	noTransportation: "No hay métodos de envío disponibles",

	"tkyouorder": "Gracias por tu pedido",
	"orderDate": "Fecha del pedido",
	"ordeAmount": "Importe del pedido",
	"paymentAddress": "Dirección de pago",
	"zipCode": "Código postal",
	customizationFee: "Tarifa de personalización"

}